module.exports = __webpack_public_path__ + "img/healthOn.d045a8e7.png";